import {useState} from 'react';
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import htmlToDraft from 'html-to-draftjs'
import { EditorState, ContentState} from 'draft-js';
// ** Reactstrap Imports
import { Row, Col, Card, CardBody, CardText, Form, Label, Input, Button } from 'reactstrap';
import { useForm, Controller } from 'react-hook-form';
import Select, { components } from 'react-select'; // eslint-disable-line
import axios from 'axios';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom'
import { BiLeftArrowAlt } from 'react-icons/bi';
import useAuth from '../hooks/useAuth';

const AddContact = () => {
  const { auth } = useAuth();

  const initialContent = `
  <p>Cupcake ipsum dolor sit. Amet dessert donut candy chocolate bar cotton dessert candy chocolate. Candy muffin danish. Macaroon brownie jelly beans marzipan cheesecake oat cake. Carrot cake macaroon chocolate cake. Jelly brownie jelly. Marzipan pie sweet roll.</p>
  <p>Liquorice dragée cake chupa chups pie cotton candy jujubes bear claw sesame snaps. Fruitcake chupa chups chocolate bonbon lemon drops croissant caramels lemon drops. Candy jelly cake marshmallow jelly beans dragée macaroon. Gummies sugar plum fruitcake. Candy canes candy cupcake caramels cotton candy jujubes fruitcake.</p>
  `

  const contentBlock = htmlToDraft(initialContent)
  const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks)
  const editorState = EditorState.createWithContent(contentState)

   // ** States
   const [content, setContent] = useState(editorState);
   let initialState = {
      contactName: '',
      designation: '',
      phoneOne: '',
      phoneTwo: '',
      emailOne: '',
      emailTwo: ''
  };
   const [contactInfo, setContactInfo] = useState(initialState)




    const handleChange = (event) => {
        const { value, name } = event.target
        setContactInfo(prevValue => {
            return({
                ...prevValue,
                [name]: value
            })
        });
    }

   
    const handleSaveClick = async (event) => {
        event.preventDefault();

        const formData = new FormData();
        formData.append('contactName', contactInfo.contactName);
        formData.append('designation', contactInfo.designation);
        formData.append('phoneOne', contactInfo.phoneOne);
        formData.append('phoneTwo', contactInfo.phoneTwo);
        formData.append('emailOne', contactInfo.emailOne);
        formData.append('emailTwo', contactInfo.emailTwo);
    

        try {
            const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/contacts/save-contact`, formData, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                    'Authorization': 'Bearer ' + auth.accessToken
                }
            })

            toast.success(res.data.message, {
                className: "success-toast",
                autoClose: 3000,
                position: toast.POSITION.BOTTOM_RIGHT
            })
            setContactInfo(initialState)

            // history.push('/')
        } catch (error) {
          error.response.data.message ? toast.error(error.response.data.message, {
            className: "error-toast",
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000
            }) :  toast.error(error.response.data.error, {
              className: "error-toast",
              position: toast.POSITION.BOTTOM_RIGHT,
              autoClose: 3000
          })
        }
    }


    const handleReset = async (event) => {
      event.preventDefault();
      setContactInfo(initialState)
      
    }
 
  return (
    <div className="container">
      <Row sm="12">
        <h5 className="sec-header">Add Contact</h5>
      </Row> 
      <Row sm='12'>
        <Card>
            <CardBody>
            {/* <Col sm='12' className='mb-2'>
            <Label className='form-label'>Content</Label>
            <Editor editorState={content} onEditorStateChange={data => setContent(data)} />
          </Col> */}
          <Col sm='12' className='mb-2'>
          <Form>
            
            <div className='mb-1'>
              <Label className='form-label' for='title'>
                Contact Name <span className='text-danger'>*</span>
              </Label>
              <Input
                id='name'
                type='text'
                className='me-1'
                name='contactName'
                required={true}
                value={contactInfo.contactName}
                onChange={handleChange}
                // {...register("contactName", {
                //   required: "Required",
                // })}
              />
            {/* {errors.contactName && <p className='error-text'>This field is required</p>} */}

            </div>

            <div className='mb-1'>
              <Label className='form-label' for='title'>
                Designation <span className='text-danger'>*</span>
              </Label>
              <Input
                id='designation'
                type='text'
                className='me-1'
                name='designation'
                required={true}
                value={contactInfo.designation}
                onChange={handleChange}
              />
            </div>

            <div className='mb-1'>
              <Label className='form-label' for='title'>
                Phone <span className='text-danger'>*</span>
              </Label>
              <Input
                id='phone'
                type='text'
                className='me-1'
                name='phoneOne'
                required={true}
                value={contactInfo.phoneOne}
                onChange={handleChange}
              />
            </div>

            <div className='mb-1'>
              <Label className='form-label' for='title'>
                Email <span className='text-danger'>*</span>
              </Label>
              <Input
                id='email'
                type='email'
                className='me-1'
                name='emailOne'
                required={true}
                value={contactInfo.emailOne}
                onChange={handleChange}
              />
            </div>
            <Row className='pt-2'>
              <Col>
              <div className='mb-1'>
                <Button
                  block
                  color="success"
                  type='submit'
                  onClick={handleSaveClick}
                >
                  Save
                </Button>
              </div>
          
              </Col>
              <Col>
                <div className='mb-1'>
                  <Button
                    block
                    color="warning"
                    onClick={handleReset}
                  >
                    Reset
                  </Button>
                </div>         
              </Col>
            </Row>
          </Form>
            
          </Col>
          </CardBody>
        </Card>
          
      </Row>
      {/* <form onSubmit={handleSubmit(onSubmit)}>
      <input defaultValue="test" {...register("example")} />
      
      <input {...register("exampleRequired", { required: true })} />
      {errors.exampleRequired && <span>This field is required</span>}
      
      <input type="submit" />
    </form> */}
      <Row sm="12" className="mt-4 text-center">
          <Link to={"/contacts/view"} className="go_back" >
            <BiLeftArrowAlt size={30} />  Go to Contact List
          </Link>
      </Row> 
    </div>
  );
};

export default AddContact;
